import styled from 'styled-components'
import { ResponsiveImage } from '../../../elements/images/ResponsiveImage/ResponsiveImage'
import { useMediaSelect } from '../../../style/media'

const BgImage = styled(ResponsiveImage)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: -1;
`

export const RegisterBackground = () => {
  const props = useMediaSelect({
    md: { publicId: 'web/register-wizard/register-bg', maxHeight: 934, aspectRatio: 2.054 },
    xs: { publicId: 'web/register-wizard/register-bg-mobile', maxHeight: 900, aspectRatio: 0.833 },
  })
  return <BgImage {...props} />
}
